import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import CountrySidebar from 'components/CountrySidebar';
import CountryEditTabs from 'components/CountryEditTabs';

import { withData } from 'lib';
import { SettingsCountryEditPageQuery } from '__generated__/SettingsCountryEditPageQuery.graphql';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';

const query = graphql`
  query SettingsCountryEditPageQuery(
    $id: ID!
    $first: Int!
    $after: String
    $search: String
  ) {
    country(id: $id) {
      name

      ...CountryEditTabs_country
      ...CountrySidebar_country
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsCountryEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/countries', name: 'Vietos' },
];

const SettingsCountryEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { country } = usePreloadedQuery<SettingsCountryEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!country) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<CountrySidebar country={country} />}
      breadcrumbs={[...breadcrumbs, { name: country.name }]}>
      <CountryEditTabs country={country} />
    </PageWithSidebar>
  );
};

export default withData<SettingsCountryEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams, currentUser }) => ({
    id: routeParams.id,
    first: currentUser.itemsPerPage,
  }),
})(SettingsCountryEditPage);
